(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-warm-products]').forEach((section) => {
      if (section.dataset.warmProductsReady === 'true') return;
      section.dataset.warmProductsReady = 'true';
      section.querySelectorAll('[data-product-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.productFilter;
          section.querySelectorAll('[data-product-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
          section.querySelectorAll('[data-product-group]').forEach((card) => {
            card.hidden = filter !== 'all' && card.dataset.productGroup !== filter;
          });
          section.querySelector('.wh-product-grid')?.scrollTo({ left: 0, behavior: 'smooth' });
        });
      });
    });
    root.querySelectorAll('[data-warm-collections]').forEach((section) => {
      if (section.dataset.warmCollectionsReady === 'true') return;
      section.dataset.warmCollectionsReady = 'true';
      const viewAll = section.querySelector('[data-collection-view-all]');
      section.querySelectorAll('[data-collection-tab]').forEach((button) => {
        button.addEventListener('click', () => {
          const panelId = button.dataset.collectionTab;
          section.querySelectorAll('[data-collection-tab]').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          section.querySelectorAll('[data-collection-panel]').forEach((panel) => {
            panel.hidden = panel.dataset.collectionPanel !== panelId;
          });
          section.querySelector(`[data-collection-panel="${panelId}"] .wh-product-grid`)?.scrollTo({ left: 0, behavior: 'smooth' });
          if (viewAll && button.dataset.viewAll) viewAll.href = button.dataset.viewAll;
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
